if (!customElements.get("plug-brands-slider")) {
    class PlugBrandsSlider extends HTMLElement {
        constructor() {
            super();
            window.PLUG.utils.bindThisToAllMethods(this);
        }

        connectedCallback() {
            this.elements = {
                slider: this.querySelector(".plug-brands-slider__slider"),
                slides: this.getElementsByClassName("swiper-slide"),
            };

            if (this.dataset.blockInit !== "true") {
                this.init();
            }
        }

        init() {
            this.dataset.blockInit = "false";
            this.slider = this.initSlider();
            window.PLUG.utils.afterNextFrame(async () => {
                this.elements.slider.closest(".plug-brands-slider__inner").classList.remove("is-see-through");
            });
        }

        initSlider() {
            return new window.Swiper(".plug-brands-slider__slider-wrapper", {
                modules: window.PLUG.swiperModules,
                direction: "horizontal",
                loop: false,
                slidesPerView: Number(this.dataset.slidesPerView) ?? 2,
                spaceBetween: Number(this.dataset.spaceBetween) ?? 16,
                breakpoints: JSON.parse(this.dataset.breakpoints),
                resistanceRatio: 0.65,
                navigation: {
                    nextEl: ".plug-brands-slider-button-next",
                    prevEl: ".plug-brands-slider-button-prev",
                    lockClass: "hidden"
                },
            });
        }
    }

    customElements.define("plug-brands-slider", PlugBrandsSlider);
}
